import axios from 'axios';
import { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import "react-quill/dist/quill.snow.css";
import Swal from 'sweetalert2';

export default function PrivacyPolicy() {
    const [description, setDescription] = useState("");

    const getData = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL}/privacy-policy/1`);
            if (res.status === 200) {
                setDescription(res.data.data);
            } else {
                setDescription([]);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            if (!description.description || description.description.trim() === "") {
                Swal.fire({
                    title: "Please enter content",
                    icon: "warning",
                });
                return;
            }

            const res = await axios.put(
                `${process.env.REACT_APP_BACKEND_BASE_URL}/privacy-policy/update/1`,
                { description }
            );

            if (res.status === 200) {
                Swal.fire({
                    icon: "success",
                    title: "Updated Successfully",
                    timer: 1500,
                });
            } else {
                Swal.fire({
                    title: "Update Failed",
                    icon: "error",
                });
            }
        } catch (err) {
            console.error("Update Error:", err);
            Swal.fire({
                title: "Something went wrong",
                icon: "error",
            });
        }
    };

    const modules = {
        toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
        ],
    };

    const handleChange = (value) => {
        setDescription((prevContent) => ({
            ...prevContent,
            description: value,
        }));
    };

    return (
        <div className="main-content">
            <div className="page-wrapper page-settings">
                <div className="content">
                    <nav aria-label="breadcrumb" style={{ '--bs-breadcrumb-divider': 'none' }}>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item active" aria-current="page">Privacy Policy</li>
                        </ol>
                    </nav>

                    <div className="content-page-header content-page-headersplit">
                        <h5>Privacy Policy</h5>
                    </div>

                    <form className="col-md-10" onSubmit={handleSubmit}>
                        <ReactQuill
                            theme="snow"
                            modules={modules}
                            value={description.description}
                            onChange={handleChange}
                            style={{ height: "300px", marginBottom: "50px" }}
                        />

                        <button
                            type="submit"
                            className="btn btn-primary mt-3"
                            style={{ padding: "10px 25px" }}
                        >
                            Update
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
